import { showToast } from "../../store/toast/actions";

export default function errorHandler(error: any) {
  if (error.response?.data?.error) {
    return showToast(error.response?.data?.error, "danger");
  } else {
    return showToast("Não foi possível realizar a operação", "danger");
  }
}
